import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useCategories } from '../../context/CategoryContext';

const DesktopMenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  background-color: #4CAF50;
`;

const MobileMenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  background-color: white;
`;

const MenuItem = styled.li`
  // Common styles for both desktop and mobile
`;

const DesktopMenuLink = styled(Link)`
  text-decoration: none;
  color: rgba(255, 255, 255, 0.8);
  padding: 15px 20px;
  display: block;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 14px;
  transition: color 0.3s;

  &:hover, &.active {
    color: white;
  }
`;

const MobileMenuLink = styled(Link)`
  text-decoration: none;
  color: #333;
  padding: 15px 20px;
  display: block;
  font-size: 16px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
`;

const Menu = ({ isMobile, toggleMobileMenu }) => {
  const { categories, loading } = useCategories();
  const location = useLocation();

  if (loading) {
    return <p>Loading categories...</p>;
  }

  if (!categories || categories.length === 0) {
    return <p>No categories available.</p>;
  }

  const MenuList = isMobile ? MobileMenuList : DesktopMenuList;
  const MenuLink = isMobile ? MobileMenuLink : DesktopMenuLink;

  return (
    <MenuList>
      <MenuItem>
        <MenuLink 
          to="/" 
          className={location.pathname === '/' ? 'active' : ''}
          onClick={isMobile ? toggleMobileMenu : null}
        >
          Home
        </MenuLink>
      </MenuItem>
      {categories.map((category) => (
        <MenuItem key={category.id}>
          <MenuLink 
            to={`/categories/${category.slug}`}
            className={location.pathname === `/categories/${category.slug}` ? 'active' : ''}
            onClick={isMobile ? toggleMobileMenu : null}
          >
            {category.name}
          </MenuLink>
        </MenuItem>
      ))}
      <MenuItem>
        <MenuLink 
          to="/specials"
          className={location.pathname === '/specials' ? 'active' : ''}
          onClick={isMobile ? toggleMobileMenu : null}
        >
          Specials
        </MenuLink>
      </MenuItem>
      <MenuItem>
        <MenuLink 
          to="/about-us"
          className={location.pathname === '/about-us' ? 'active' : ''}
          onClick={isMobile ? toggleMobileMenu : null}
        >
          About Us
        </MenuLink>
      </MenuItem>
    </MenuList>
  );
};

export default Menu;